import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// Enable production mode is "production" is true on the environment
if (environment.production) {
    enableProdMode();
}

if (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
    // eslint-disable-next-line no-console
    console.info("[clio-provider] API base:", environment.uri, environment["LOCAL_DEV_MARKER"] ? "(local build)" : "(runtime localhost override)");
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
